import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import {
    IconChevronLeft,
    mediaMixin,
    spaceMixin,
    Spacer,
    Text,
} from '@zillow/constellation';

export const StyledAddressDetails = styled.div`
    overflow: hidden;

    ${mediaMixin('lg', css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: ${spaceMixin('md')};
        height: 115px;
    `)}
`;

export const StyledDesktopStatusSpacer = styled(Spacer)`
    display: none;

    ${mediaMixin('lg', css`
       display: block;
       padding-top: ${spaceMixin('sm')};
    `)}
`;

export const StyledStreetText = styled(Text)`
    && {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: ${({ isScrolledMobile }) => (isScrolledMobile ? '100%' : 'initial')};
        text-align: ${({ isScrolledMobile }) => (isScrolledMobile ? 'center' : 'left')};
    }
`;

export const StyledLink = styled(Link)`
    flex-direction: row;
    align-items: center;
    width: fit-content;
    font-weight: bold;
    display: ${({ isScrolledMobile }) => (isScrolledMobile ? 'flex' : 'none')};

    span {
        color: unset;
    }
`;

export const StyledIconChevronLeft = styled(IconChevronLeft)`
    margin-right: ${spaceMixin('xs')};
`;

export const StyledCityStateText = styled(Text)`
    && {
        display: ${({ isScrolledMobile }) => (isScrolledMobile ? 'none' : 'block')};
    }
`;
